/* Quorix 3D hero: the paw Q logo in 3D with floating pet props (three.js r128) */
(function () {
  'use strict';

  var stage = document.querySelector('[data-hero-3d]');
  if (!stage || !window.THREE) return;

  try {
    init(window.THREE);
  } catch (err) {
    if (window.console) console.warn('Quorix 3D hero disabled:', err);
  }

  function init(T) {
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var canvas = document.createElement('canvas');
    var renderer;
    try {
      renderer = new T.WebGLRenderer({ canvas: canvas, antialias: true, alpha: true, powerPreference: 'high-performance' });
    } catch (e) {
      return;
    }
    if (!renderer.getContext()) return;

    renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
    renderer.outputEncoding = T.sRGBEncoding;
    renderer.toneMapping = T.ACESFilmicToneMapping;
    renderer.toneMappingExposure = 0.92;
    renderer.setClearColor(0x000000, 0);
    stage.insertBefore(canvas, stage.firstChild);

    var scene = new T.Scene();
    var camera = new T.PerspectiveCamera(30, 1, 0.1, 100);
    camera.position.set(0, 0, 11.2);

    /* Brand colors are sRGB hex values; convert so they render true with sRGB output */
    function srgb(hex) { return new T.Color(hex).convertSRGBToLinear(); }

    /* Studio environment for soft reflections */
    var pmrem = new T.PMREMGenerator(renderer);
    var env = new T.Scene();
    env.background = new T.Color(0x0b2545);
    var panel = new T.PlaneGeometry(1, 1);
    function addPanel(color, intensity, x, y, z, sx, sy) {
      var m = new T.Mesh(panel, new T.MeshBasicMaterial({ color: new T.Color(color).multiplyScalar(intensity), side: T.DoubleSide }));
      m.position.set(x, y, z);
      m.scale.set(sx, sy, 1);
      m.lookAt(0, 0, 0);
      env.add(m);
    }
    addPanel(0xffffff, 1.4, 0, 6, 4, 8, 3);
    addPanel(0xffffff, 0.7, 6, 1, 3, 2.5, 7);
    addPanel(0x5fd0cf, 0.9, -6, 0, -2, 3, 7);
    addPanel(0xc8a96a, 0.6, 0, -6, 2, 7, 2.5);
    scene.environment = pmrem.fromScene(env, 0.04).texture;

    /* Lights */
    scene.add(new T.AmbientLight(0xffffff, 0.22));
    var key = new T.DirectionalLight(0xffffff, 1.5);
    key.position.set(4, 5, 7);
    scene.add(key);
    var rim = new T.DirectionalLight(0x5fd0cf, 1.3);
    rim.position.set(-6, 2, -5);
    scene.add(rim);
    var warm = new T.PointLight(0xc8a96a, 0.7, 30);
    warm.position.set(-4, -3, 5);
    scene.add(warm);

    /* Paw Q geometry, built from the logo's exact SVG construction (256 grid) */
    var U = 1 / 40;
    function P(x, y) { return [(x - 128) * U, -(y - 146) * U]; }

    function ringShape(cx, cy, R, r) {
      var c = P(cx, cy);
      var s = new T.Shape();
      s.absarc(c[0], c[1], R * U, 0, Math.PI * 2, false);
      var hole = new T.Path();
      hole.absarc(c[0], c[1], r * U, 0, Math.PI * 2, true);
      s.holes.push(hole);
      return s;
    }
    function ellipseShape(cx, cy, rx, ry, deg) {
      var c = P(cx, cy);
      var s = new T.Shape();
      s.absellipse(c[0], c[1], rx * U, ry * U, 0, Math.PI * 2, false, -deg * Math.PI / 180);
      return s;
    }
    function capsuleShape(len, h) {
      var r = (h / 2) * U, a = ((len - h) / 2) * U;
      var s = new T.Shape();
      s.moveTo(-a, -r);
      s.lineTo(a, -r);
      s.absarc(a, 0, r, -Math.PI / 2, Math.PI / 2, false);
      s.lineTo(-a, r);
      s.absarc(-a, 0, r, Math.PI / 2, Math.PI * 1.5, false);
      return s;
    }

    var depth = 0.62;
    var extrude = { depth: depth, bevelEnabled: true, bevelThickness: 0.14, bevelSize: 0.075, bevelSegments: 8, curveSegments: 64 };
    function solid(shapes) {
      var g = new T.ExtrudeGeometry(shapes, extrude);
      g.translate(0, 0, -depth / 2);
      return g;
    }

    var teal = new T.MeshPhysicalMaterial({ color: srgb(0x139a9c), roughness: 0.3, metalness: 0.08, clearcoat: 1, clearcoatRoughness: 0.14, envMapIntensity: 0.8 });

    var paw = new T.Group();
    paw.add(new T.Mesh(solid([
      ringShape(128, 160, 64, 38),
      ellipseShape(60, 104, 16, 21, -30),
      ellipseShape(100, 62, 17, 22, -10),
      ellipseShape(156, 62, 17, 22, 10),
      ellipseShape(196, 104, 16, 21, 30)
    ]), teal));

    var tail = new T.Mesh(solid([capsuleShape(56, 22)]), teal);
    var tp = P(164.8, 196.8);
    tail.position.set(tp[0], tp[1], 0.04);
    tail.rotation.z = -Math.PI / 4;
    paw.add(tail);

    var pawScale = 0.78;
    paw.scale.setScalar(pawScale);
    var pivot = new T.Group();
    pivot.add(paw);
    scene.add(pivot);

    /* Floating props */
    var ivory = new T.MeshPhysicalMaterial({ color: srgb(0xefe6d6), roughness: 0.45, metalness: 0, clearcoat: 0.5, clearcoatRoughness: 0.3, envMapIntensity: 0.7 });
    var gold = new T.MeshPhysicalMaterial({ color: srgb(0xc8a96a), roughness: 0.28, metalness: 0.9, clearcoat: 0.3, envMapIntensity: 1 });
    var navy = new T.MeshPhysicalMaterial({ color: srgb(0x2a5a8f), roughness: 0.22, metalness: 0.2, clearcoat: 1, envMapIntensity: 0.8 });

    function makeBone() {
      var g = new T.Group();
      var shaft = new T.Mesh(new T.CylinderGeometry(0.15, 0.15, 1.15, 32), ivory);
      shaft.rotation.z = Math.PI / 2;
      g.add(shaft);
      [[-0.6, 0.15], [-0.6, -0.15], [0.6, 0.15], [0.6, -0.15]].forEach(function (p) {
        var k = new T.Mesh(new T.SphereGeometry(0.24, 32, 24), ivory);
        k.position.set(p[0], p[1], 0);
        g.add(k);
      });
      return g;
    }

    var props = [];
    function addProp(obj, x, y, z, speed, amp, spin) {
      obj.position.set(x, y, z);
      obj.userData = { baseY: y, speed: speed, amp: amp, spin: spin, phase: Math.random() * Math.PI * 2 };
      scene.add(obj);
      props.push(obj);
    }

    var bone = makeBone();
    bone.rotation.set(0.4, 0.3, 0.5);
    bone.scale.setScalar(0.85);
    addProp(bone, 1.85, 1.75, 0.4, 0.9, 0.14, [0.002, 0.004, 0.001]);
    addProp(new T.Mesh(new T.SphereGeometry(0.36, 48, 32), gold), -2.0, -1.55, 0.7, 0.7, 0.16, [0, 0.006, 0]);
    addProp(new T.Mesh(new T.SphereGeometry(0.18, 32, 24), navy), -2.0, 1.65, -0.6, 1.1, 0.12, [0, 0, 0]);
    var ring = new T.Mesh(new T.TorusGeometry(0.26, 0.075, 24, 64), gold);
    ring.rotation.set(1.1, 0.2, 0);
    addProp(ring, 2.0, -1.65, -0.2, 0.8, 0.12, [0.006, 0.003, 0]);
    addProp(new T.Mesh(new T.SphereGeometry(0.1, 24, 16), ivory), 0.3, 2.3, -1.2, 1.3, 0.1, [0, 0, 0]);

    /* Interaction: drag to spin with inertia, gentle pointer parallax */
    var dragging = false, lastX = 0, velocity = 0, spin = 0;
    var targetTiltX = 0, targetTiltY = 0, tiltX = 0, tiltY = 0;

    /* The whole hero is a drag surface (except its links and buttons), not only the visible shapes */
    var surface = stage.closest('.hero') || stage;
    function endDrag() {
      dragging = false;
      surface.classList.remove('is-dragging');
    }
    surface.addEventListener('pointerdown', function (e) {
      if (e.button !== undefined && e.button !== 0) return;
      if (e.target.closest && e.target.closest('a, button, input, select, textarea, label')) return;
      dragging = true;
      lastX = e.clientX;
      surface.classList.add('is-dragging');
      if (surface.setPointerCapture) {
        try { surface.setPointerCapture(e.pointerId); } catch (err) { /* noop */ }
      }
    });
    surface.addEventListener('pointerup', endDrag);
    surface.addEventListener('pointercancel', endDrag);
    window.addEventListener('pointerup', endDrag);
    surface.addEventListener('pointermove', function (e) {
      var rect = canvas.getBoundingClientRect();
      targetTiltY = Math.max(-0.5, Math.min(0.5, (e.clientX - rect.left) / rect.width - 0.5)) * 0.5;
      targetTiltX = Math.max(-0.5, Math.min(0.5, (e.clientY - rect.top) / rect.height - 0.5)) * 0.35;
      if (dragging) {
        var dx = e.clientX - lastX;
        lastX = e.clientX;
        velocity = dx * 0.012;
        spin += velocity;
        if (reduceMotion) render(0);
      }
    });
    surface.addEventListener('pointerleave', function () { targetTiltX = 0; targetTiltY = 0; });

    /* Sizing */
    function resize() {
      var w = stage.clientWidth, h = stage.clientHeight;
      if (!w || !h) return;
      renderer.setSize(w, h, false);
      camera.aspect = w / h;
      camera.updateProjectionMatrix();
      if (reduceMotion) render(0);
    }
    if (window.ResizeObserver) new ResizeObserver(resize).observe(stage);
    else window.addEventListener('resize', resize);
    resize();

    /* Loop */
    var running = true, start = performance.now(), raf = 0;
    function render(t) {
      var time = t / 1000;
      if (!dragging) {
        velocity *= 0.94;
        spin += velocity;
      }
      tiltX += (targetTiltX - tiltX) * 0.06;
      tiltY += (targetTiltY - tiltY) * 0.06;
      var sway = reduceMotion ? 0 : Math.sin(time * 0.55) * 0.42;
      pivot.rotation.y = sway + spin + tiltY;
      pivot.rotation.x = tiltX + (reduceMotion ? 0 : Math.sin(time * 0.4) * 0.05);
      pivot.position.y = reduceMotion ? 0 : Math.sin(time * 0.9) * 0.06;

      props.forEach(function (o) {
        var d = o.userData;
        if (!reduceMotion) {
          o.position.y = d.baseY + Math.sin(time * d.speed + d.phase) * d.amp;
          o.rotation.x += d.spin[0];
          o.rotation.y += d.spin[1];
          o.rotation.z += d.spin[2];
        }
      });
      renderer.render(scene, camera);
    }
    function loop(now) {
      if (!running) return;
      render(now - start);
      raf = requestAnimationFrame(loop);
    }

    if ('IntersectionObserver' in window && !reduceMotion) {
      new IntersectionObserver(function (entries) {
        var visible = entries[0].isIntersecting;
        if (visible && !running) { running = true; raf = requestAnimationFrame(loop); }
        if (!visible) { running = false; cancelAnimationFrame(raf); }
      }).observe(stage);
    }
    document.addEventListener('visibilitychange', function () {
      if (reduceMotion) return;
      if (document.hidden) { running = false; cancelAnimationFrame(raf); }
      else if (!running) { running = true; raf = requestAnimationFrame(loop); }
    });

    if (reduceMotion) {
      running = false;
      render(0);
    } else {
      raf = requestAnimationFrame(loop);
    }
    stage.classList.add('is-3d');
  }
})();
